<template>
	<div class="container">
		<div class="close_chat" v-if="chatShow == false">
			<img src="@/assets/chat/icon_kf_logo.png">
			<img src="@/assets/chat/icon_kf_o.png" @click="chatShow = true">
		</div>
		<div class="open_chat" v-else>
			<div class="chat_title">
				<div class="img_text">
					<img src="@/assets/chat/kf.png" style="margin-right: 10px;">在线客服
				</div>
				<div   @click="chatShow = false">
					<img src="@/assets/chat/icon_kf_j.png">
					<!-- <img src="@/assets/chat/close1.png" style="width: 25px;margin-left: 10px;"> -->
					
				</div>
			</div>
			<div class="chat_content">
				<iframe :src="'https://m.sz517.com/user_chat/index?user_id='+user_id" width="360" height="653" ></iframe>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: [],
		data() {
			return {
			user_id:'',
			user_name:'',
			chatShow:false,
			}
		},
		created() {
		if((localStorage.getItem("UserToken")??'') !=='' ){
				let userInfo = JSON.parse(localStorage.getItem('userInfo'))
		this.user_id = userInfo.id
		this.user_name = userInfo.nickname	
		//console.log(this.user_id)
			
		}	
		},
		methods:{
			
		}
	}
</script>

<style scoped="scoped" lang="scss">
	.close_chat {
		height: 46px;
		width: 235px;
		background: #E60012;
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 0 15px;
		position: fixed;
		right: 0;
		bottom: 0;

	}
	.top a{
		height: 0px !important;
		
	}
	.chat_content{
		background: #fff;
		iframe{
			height: 493px !important;
			background: #fff !important;
		}
	}
	.open_chat{
		position: fixed;
		right: 0;
		bottom: 0;
		width: 360px;
		background: #fff;
		z-index: 99999999;
		height: 572px !important;
		.chat_title{
			height: 40px;
			background: #E60012;
			display: flex;
			align-items: center;
			justify-content: space-between;
			padding: 0 15px;
			color: #fff;
		}
	}
</style>
